<form [formGroup]="loginForm" (ngSubmit)="login()">
  <!-- Start::input email -->
  <div class="field mb-4 flex flex-column">
    <label for="email" class="font-semibold text-900">Correo eletrónico</label>
    <app-email-input formControlName="email" />
  </div>
  <!-- End::input email -->

  <!-- Start::input contraseña -->
  <div class="field mb-4 flex flex-column">
    <label for="password" class="font-semibold text-900">Contraseña</label>
    <p-password
      formControlName="password"
      pAutoFocus
      [autofocus]="true"
      [toggleMask]="true"
      [feedback]="false"
    />
  </div>

  <div class="flex align-items-center justify-content-end mb-5 mr-1">
    <a
      href="sitio/recover"
      class="font-medium text-blue-500 hover:text-blue-700 cursor-pointer transition-colors transition-duration-150 underline"
      >Olvidé mi contraseña</a
    >
  </div>

  <p-button
    (click)="login()"
    [label]="isLoading() ? '' : 'Iniciar sesión'"
    class="w-full"
    styleClass="w-full"
    type="submit"
    [disabled]="isLoading()"
  >
    <ng-template pTemplate="icon">
      @if(isLoading()){
      <i class="fa-duotone fa-solid fa-loader fa-spin-pulse fa-xl"></i>
      }
    </ng-template>
  </p-button>
</form>

<!-- Start::toast de error o éxito -->
<p-toast />
<!-- End::toast de error o éxito -->
